import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { QmAutocompleteData } from 'src/uikit/qm-autocomplete/qm-autocomplete-data';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { HeaderService } from '../../services/header.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers:[
    MessageService
  ]
})
export class HeaderComponent implements OnInit {
  versionApp: string = '';
  items: MenuItem[] = [];
  itemsmenu: QmAutocompleteData[] = [];
  listaSuggestions: QmAutocompleteData[] = [];
  showUser: boolean = true;
  showgroup: boolean = true;
  showSetup: boolean = true;
  showModel: boolean = true;
  showSurvey: boolean = true;
  showProcess: boolean = false;
  moduleValue!: string;

  constructor(
    private authService: AuthService,
    private router: Router,
    private headerService: HeaderService,
    private messageService: MessageService
  ) {

  }

  ngOnInit() {
    this.items = [
      {
          label: 'Módulos',
          icon: 'pi pi-sitemap',
          items: [
              {label: 'Usuários', icon: 'pi pi-users', routerLink: 'users/user', visible: this.showUser},
              {label: 'Clientes', icon: 'pi pi-users', routerLink: 'cliente/cliente', visible: true}
          ]
      }
    ];

    var menuListFlat = this.flatMenuStructure(JSON.parse(JSON.stringify(this.items)));

    for (const item of menuListFlat) {
        if (item.routerLink !== undefined) {
          this.itemsmenu.push({label: item.label?? 'Item', value: {url: item.routerLink, visible: item.visible }})
        }
    }

    this.headerService.getVersionApp().subscribe ({
      next: (data) => this.versionApp = data,
      error: (err) => {
        this.messageService.add({severity:'error', summary:'Falha', detail: err.error.error})
      }
    });

  }

  onSearchData(event: any): void {
    this.listaSuggestions = this.itemsmenu.filter(el => el.label?.trim().toLowerCase().indexOf(event.query?.trim().toLowerCase()) !== -1);
  }

  onSelectData(event: any) {
      this.router.navigate([event.value.url]);
  }

  flatMenuStructure(itemTree: MenuItem[]): MenuItem[] {
    let items: MenuItem[] = [];
    const flattenMembers = itemTree.map(m => {
      if (m.items && m.items.length) {
        items = [...items, ...m.items];
      }
      return m;
    });

    return flattenMembers.concat(items.length ? this.flatMenuStructure(items) : items);
  };

  logout() {
    this.authService.logout();
  }
}
